import { render, staticRenderFns } from "./classList.vue?vue&type=template&id=683e01f8"
import script from "./classList.vue?vue&type=script&lang=js"
export * from "./classList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports